import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-table"
  }, [_vm.ruleEditDialog ? _c('core-dtwin-rule-edit', {
    ref: "ruleEditor",
    attrs: {
      "value": _vm.targetRuleIndex >= 0 ? _vm.rules[_vm.targetRuleIndex] : _vm.emptyIndexObject,
      "states": _vm.value,
      "disabled": _vm.ruleEditServerRequest || _vm.disabled || !_vm.hasTwinEditPermission || _vm.isCreatedByTemplate,
      "hasTwinEditPermission": _vm.hasTwinEditPermission,
      "dtwin": _vm.dtwin,
      "template": _vm.template,
      "isCreatedByTemplate": _vm.isCreatedByTemplate
    },
    on: {
      "save": _vm.persistRule,
      "cancel-edit": function ($event) {
        _vm.ruleEditDialog = false;
      },
      "open-state": _vm.openState
    }
  }) : _vm._e(), _c(VDialog, {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.deleteDialog,
      callback: function ($$v) {
        _vm.deleteDialog = $$v;
      },
      expression: "deleteDialog"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.deleteConfirmation')) + "\n      ")]), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.cancel')))]), _c(VBtn, {
    attrs: {
      "color": "red",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.deleteDialog = false;
        _vm.deleteRule(_vm.targetRuleIndex);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.tenant.bridges.deleteButton')) + "\n        ")])], 1)], 1)], 1), _vm.historyDialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.historyDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistory')) + "\n    ")];
      },
      proxy: true
    }], null, false, 89683544)
  }, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-date-time-picker', {
    staticClass: "mt-0",
    attrs: {
      "from": _vm.historyQueryStartDate / 1000,
      "to": _vm.historyQueryEndDate / 1000,
      "isRange": ""
    },
    on: {
      "date:picked": _vm.handleDatePicked
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandFilter')
    },
    model: {
      value: _vm.executionHistoryCmdFilter,
      callback: function ($$v) {
        _vm.executionHistoryCmdFilter = $$v;
      },
      expression: "executionHistoryCmdFilter"
    }
  })], 1), _c(VDataTable, {
    attrs: {
      "headers": _vm.executionHistoryTableHeaders,
      "footer-props": _vm.executionHistoryTableFooter,
      "items": _vm.executionHistory,
      "server-items-length": _vm.executionHistoryItemsLength,
      "options": _vm.executionHistoryTableOptions,
      "show-expand": true,
      "expanded": _vm.expandedExecution,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.executionHistoryTableOptions = $event;
      },
      "update:expanded": function ($event) {
        _vm.expandedExecution = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.commands",
      fn: function ({
        item
      }) {
        return [_vm._v("\n        " + _vm._s(_vm.printRuleExecutionCommands(item)) + "\n      ")];
      }
    }, {
      key: "item.date",
      fn: function ({
        item
      }) {
        return [_vm._v("\n        " + _vm._s(_vm.localizeDate(item.date)) + "\n      ")];
      }
    }, {
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_c('codemirror', {
          attrs: {
            "options": _vm.cmOptions,
            "value": JSON.stringify(item.properties, null, 1)
          }
        })], 1)];
      }
    }], null, false, 4259300815)
  })], 1) : _vm._e(), _vm.executionHistoryExportDialog ? _c('core-dtwin-rule-execution-history-export', {
    attrs: {
      "ruleId": _vm.executionHistoryRule.id
    },
    on: {
      "close-export-dialog": function ($event) {
        _vm.executionHistoryExportDialog = false;
      }
    }
  }) : _vm._e(), _vm.copyRuleDialog ? _c('div', [_vm.targetRuleIndex >= 0 && _vm.targetRuleIndex < _vm.rules.length ? _c('core-dtwin-rule-copy', {
    attrs: {
      "tenantId": _vm.dtwin.tenantId,
      "dtwinId": _vm.dtwin.id,
      "states": _vm.value,
      "rule": _vm.rules[_vm.targetRuleIndex]
    },
    on: {
      "close": function ($event) {
        _vm.copyRuleDialog = false;
      },
      "created": function ($event) {
        _vm.fetchTwinRules();
        _vm.copyRuleDialog = false;
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "buttons": _vm.buttons
    },
    on: {
      "addItem": _vm.addItem
    }
  }, [_c(VSimpleTable, {
    staticClass: "mt-2 mb-2",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.state')))]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.id')))]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.title')) + "\n                ")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "65"
          }
        }, [_c(VIcon, {
          attrs: {
            "small": "",
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing')
          }
        }, [_vm._v("\n                    fal fa-map-marker-check\n                  ")])], 1), _c('th', {
          staticClass: "text-center",
          attrs: {
            "width": "65"
          }
        }, [_c(VIcon, {
          attrs: {
            "small": "",
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.headline')
          }
        }, [_vm._v("\n                    fal fa-alarm-clock\n                  ")])], 1), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n                ")]), _vm.hasTwinEditPermission ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commands')) + "\n                ")]) : _vm._e(), _c('th', {
          staticClass: "text-right"
        }), _c('th', {
          staticClass: "text-right",
          staticStyle: {
            "max-width": "200px"
          }
        })])]), _c('tbody', _vm._l(_vm.rules, function (rule, i) {
          return _c('tr', {
            key: `rule_${i}`
          }, [_c('td', [_c('div', {
            staticStyle: {
              "margin": "0 auto",
              "text-align": "center"
            }
          }, [_c(VIcon, {
            attrs: {
              "color": rule.properties.disabled ? 'primary' : _vm.color,
              "size": "16"
            }
          }, [_vm._v("\n                      fal fa-lightbulb" + _vm._s(rule.properties.disabled ? '-slash' : '') + "\n                    ")]), rule.properties.stateMetrics.filter(sm => _vm.isTemplateContext ? !sm.id : !sm.stateId).length > 0 ? [_vm._v("\n                       \n                      "), _c(VIcon, {
            attrs: {
              "color": "red",
              "size": "16"
            }
          }, [_vm._v("fal fa-exclamation-triangle")])] : _vm._e()], 2)]), _c('td', [_vm._v(_vm._s(rule.id))]), _c('td', {
            staticClass: "text-left",
            staticStyle: {
              "text-overflow": "ellipsis",
              "overflow": "hidden",
              "white-space": "nowrap",
              "max-width": "260px"
            }
          }, [_vm._v("\n                  " + _vm._s(rule.properties.title) + "\n                ")]), _c('td', {
            staticClass: "text-center"
          }, [(rule.properties.geoFences || []).length ? [_c(VIcon, {
            attrs: {
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing'),
              "size": "16"
            }
          }, [_vm._v("\n                      fal fa-check-square\n                    ")])] : _vm._e()], 2), _c('td', {
            staticClass: "text-center"
          }, [(rule.properties.timeTriggers || []).length ? [_c(VIcon, {
            attrs: {
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.headline'),
              "size": "16"
            }
          }, [_vm._v("\n                      fal fa-check-square\n                    ")])] : _vm._e()], 2), _c('td', [_vm._v(_vm._s(_vm.printRuleStates(rule)))]), _vm.hasTwinEditPermission ? _c('td', [_vm.gatherRuleCommands(rule).length === 1 ? [_vm._v("\n                    " + _vm._s(_vm.gatherRuleCommands(rule)[0]) + "\n                  ")] : _c('ul', _vm._l(_vm.gatherRuleCommands(rule), function (action, j) {
            return _c('li', {
              key: `action_${rule.id}_${j}`
            }, [_vm._v("\n                      " + _vm._s(action) + "\n                    ")]);
          }), 0)], 2) : _vm._e(), !_vm.isTemplateContext ? _c('td', {
            staticClass: "text-right"
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistory'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.fetchRuleExecutionHistory(rule, {
                  resetTableOptions: true
                });
              }
            }
          }, [_vm._v("\n                    fal fa-clock\n                  ")]), _vm._v("\n                   \n                  "), _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistoryExport.buttonTitle'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.showExecutionHistoryExportDialog(rule);
              }
            }
          }, [_vm._v("\n                    fal fa-file-csv\n                  ")])], 1) : _vm._e(), _c('td', {
            staticClass: "text-center",
            attrs: {
              "data-cy": `rule-value-${rule.properties.title}`
            }
          }, [!_vm.isTemplateContext || _vm.isTemplateContext && rule.id !== '_health' ? _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.edit'),
              "small": "",
              "data-cy": `editRule_btn_${rule.properties.title}`,
              "disabled": _vm.isProductiveVersion || _vm.readonly
            },
            on: {
              "click": function ($event) {
                _vm.targetRuleIndex = i;
                _vm.ruleEditDialog = true;
              }
            }
          }, [_vm._v("\n                    fal " + _vm._s(_vm.detailButtonIcon) + "\n                  ")]) : _vm._e(), _vm._v("\n                   \n                  "), _vm.dtwin && _vm.dtwin.properties && _vm.dtwin.properties.type !== 'virtualDevice' ? [_vm.hasTwinManagePermission ? _c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.copy'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                _vm.targetRuleIndex = i;
                _vm.copyRuleDialog = true;
              }
            }
          }, [_vm._v("\n                      fal fa-copy\n                    ")]) : _vm._e(), _vm._v("\n                     \n                  ")] : _vm._e(), _c(VTooltip, {
            attrs: {
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function ({
                on
              }) {
                return [_c('div', _vm._g({
                  staticStyle: {
                    "display": "inline"
                  }
                }, on), [_vm.isTemplateContext && rule.id !== '_health' || !_vm.isTemplateContext && _vm.hasTwinManagePermission ? _c(VIcon, {
                  attrs: {
                    "disabled": _vm.isCreatedByTemplate || _vm.isProductiveVersion || _vm.readonly,
                    "color": _vm.color,
                    "title": _vm.$i18n_t('Common.delete'),
                    "small": ""
                  },
                  on: {
                    "click": function ($event) {
                      _vm.targetRuleIndex = i;
                      _vm.deleteDialog = true;
                    }
                  }
                }, [_vm._v("\n                          fal fa-trash-alt\n                        ")]) : _vm._e()], 1)];
              }
            }], null, true)
          }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.rulesConfigured', {
            deviceTemplateTitle: _vm.template ? _vm.template.title : null
          })) + "\n                  ")])], 2)]);
        }), 0)];
      },
      proxy: true
    }])
  }), _vm.rules.length === 0 ? _c(VAlert, {
    staticClass: "mb-1",
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-comment-exclamation"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.noRulesDefined')) + "\n        ")]) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };